import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
import { urlConstructor } from "@frameworks/web/config/domain";
var mfHelpDeskConfigURL = {
    getMfClientContact: urlConstructor(config.app_mf, "", "client-contact"),
};
export default mfHelpDeskConfigURL;
